import { render, staticRenderFns } from "./AssignableCrews.vue?vue&type=template&id=18f53618&scoped=true"
import script from "./AssignableCrews.vue?vue&type=script&lang=js"
export * from "./AssignableCrews.vue?vue&type=script&lang=js"
import style0 from "./AssignableCrews.vue?vue&type=style&index=0&id=18f53618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f53618",
  null
  
)

export default component.exports